module.exports = __webpack_public_path__ + "static/media/subway.8d456c05.svg";